exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[data-dusk-test] .galaxy\\:\\:common-form-inputs-VSelectComponent .vs__spinner{animation:none}", ""]);

